import type { FileFilters } from '../api/files.api'

/**
 * Typed cache keys for the files feature.
 *
 * Per ADR-0012: query keys are typed constants, never inline string arrays.
 * Prefix shape preserves compatibility with the previous inline keys
 * (`['files']`, `['files', filters]`, `['files', fileId]`, `['file-shares', fileId]`).
 */
export const filesKeys = {
	all: ['files'] as const,
	list: (filters: FileFilters = {}) => ['files', filters] as const,
	detail: (fileId: string) => ['files', fileId] as const,
	shares: (fileId: string) => ['file-shares', fileId] as const,
}
